var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.5V31M21 20.5V31M15 14.5V32.2C15 33.8802 15 34.7197 15.327 35.3614C15.6146 35.9259 16.0732 36.3857 16.6377 36.6733C17.2788 37 18.1185 37 19.7954 37H28.2046C29.8815 37 30.72 37 31.3611 36.6733C31.9256 36.3857 32.3857 35.9259 32.6733 35.3614C33 34.7203 33 33.8815 33 32.2046V14.5M15 14.5H18M15 14.5H12M18 14.5H30M18 14.5C18 13.1022 18 12.4036 18.2284 11.8523C18.5328 11.1172 19.1165 10.5328 19.8516 10.2284C20.4029 10 21.1022 10 22.5 10H25.5C26.8978 10 27.5967 10 28.148 10.2284C28.8831 10.5328 29.467 11.1172 29.7715 11.8523C29.9998 12.4036 30 13.1022 30 14.5M30 14.5H33M33 14.5H36",
    stroke: "#1F243B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35C26 39.9706 30.0294 44 35 44C39.9706 44 44 39.9706 44 35C44 30.0294 39.9706 26 35 26C30.0294 26 26 30.0294 26 35Z",
    fill: "#08C108"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33L34 37L32 35M35 44C30.0294 44 26 39.9706 26 35C26 30.0294 30.0294 26 35 26C39.9706 26 44 30.0294 44 35C44 39.9706 39.9706 44 35 44Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedTrash);
export default __webpack_public_path__ + "static/media/Deleted_Trash.970dd98361c1b648f2155505c91c2491.svg";
export { ForwardRef as ReactComponent };